import { FormControl, InputLabel, MenuItem, Select, SelectProps } from '@mui/material';
import { ChangeEvent, useState } from 'react';

import { FieldMetaData } from './types';

export type SelectMenuItemProps = {
  title: string;
  value: string;
};

type SelectTFCProps = Omit<SelectProps, 'value' | 'onChange'> & {
  onChange: (value: string, fieldMetaData: FieldMetaData) => void;
  selectMenuItems: SelectMenuItemProps[];
  isBlankValid: boolean;
  initialValue?: string;
};

export default function SelectTFC({
  onChange,
  selectMenuItems,
  isBlankValid,
  label,
  initialValue = '',
  ...props
}: SelectTFCProps) {
  const [value, setValue] = useState(initialValue);

  function handleOnChange(
    event: ChangeEvent<HTMLInputElement> | (Event & { target: { value: unknown; name: string } })
  ): void {
    const newValue = event.target.value as string;
    setValue(newValue);

    const state = newValue ? 'valid' : isBlankValid ? 'valid' : 'empty';

    onChange(newValue, { state, error: null });
  }

  return (
    <FormControl fullWidth>
      <InputLabel id={`label-${label}`} color="secondary">
        {label}{' '}
      </InputLabel>
      <Select
        labelId={`label-${label}`}
        label={label}
        value={value}
        onChange={handleOnChange}
        {...props}
        color="secondary"
      >
        {selectMenuItems.map((x) => (
          <MenuItem key={x.value} value={x.value}>
            {x.title}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
